import { useEffect, useState } from "react";
import { SurveyQuestion } from "./SurveyQuestion";
import { Card } from "react-bootstrap";
import { ChevronDown, ChevronRight } from "react-bootstrap-icons";

export function SurveyForm(props) {
	let { inspection, survey, job, className, saveAction, onChange, ...passableProps} = props;
	

	// This needs to be a copy of the survey questions
	let allQuestions = [...survey.surveyQuestions];
	
	// Let's add the job questions, if any
	if(job?.jobQuestions && job.jobQuestions.length > 0 ){
		// Need a special "section" for the job questions
		allQuestions.push({id: "jobSection", questionId:"jobSectionQuestion", question:{id: "jobSectionQuestion", newSection: true, question:job.name}})
		allQuestions = allQuestions.concat(job?.jobQuestions || []).filter(qMeta => {
			if(qMeta.id == "jobSection"){
				return true;
			}
			// Don't show previously-deleted questions
			if(qMeta.deletedAt != null) { return false; }
			
			// Don't show non-responses for read-only inspections
			if(inspection.isReadOnly) {
				let response = inspection.getResponseFor(qMeta.question.id);
				if(response.isEmpty) {
					return false;
				}
			}
			// Everything else should be shown
			return true;
		});
	}

	// Initial state is in the form
	// {
	// 	0: true,
	// 	10: true,
	// 	15: true,
	// 	...
	// }
	// The keys are the indexes of new sections
	const [sectioned, setSectioned] = useState(allQuestions.reduce((accum, qMeta) => {return qMeta.question.newSection ? {...accum, [qMeta.id]: true} : accum}, Object()));

	// Update the sectioned state when the job or survey changes
	useEffect(() => {
		if(job?.jobQuestions && job.jobQuestions.length > 0 ){
			setSectioned(allQuestions.reduce((accum, qMeta) => {return qMeta.question.newSection ? {...accum, [qMeta.id]: true} : accum}, Object()));
		} else {
			let sectionedCopy = {...sectioned};
			delete sectionedCopy.jobSection
			setSectioned(sectionedCopy);
		}
	}, [job]);

	useEffect(() => {
		setSectioned(allQuestions.reduce((accum, qMeta) => {return qMeta.question.newSection ? {...accum, [qMeta.id]: true} : accum}, Object()));
	}, [survey]);

	// Only display questions if their corresponding section is expanded
	let currDisplay = true;
	const willDisplay = allQuestions.reduce((accum, qMeta) => {
		if(qMeta.question.newSection){
			currDisplay = sectioned[qMeta.id];
			return {...accum, [qMeta.id]: true};
		}
		return {...accum, [qMeta.id]: currDisplay}
	}, {});
	
	const displayedQuestion = allQuestions.filter((qMeta) => {return willDisplay[qMeta.id]});

	const getCard = function(qMeta) {
		if(qMeta.question.newSection){
			return <Card.Title key={qMeta.id} className={"question-section"} onClick={() => { setSectioned({...sectioned, [qMeta.id]: !sectioned[qMeta.id]}) }} style={{"padding": "0.5em"}}><div>{qMeta?.question.question}</div> {sectioned[qMeta.id]? <ChevronDown style={{color:"#E4AF0A"}}/>: <ChevronRight style={{color:"#E4AF0A"}}/>}</Card.Title>
		}
		return <SurveyQuestion key={qMeta.id} questionMeta={qMeta} inspection={inspection} saveAction={saveAction} onChange={onChange}/>
	}
	
    return (
        <div className={`survey ${className}`} {...passableProps}>
			{allQuestions.length == 0 && <p>No explicit checks were completed on this inspection.  Please check final results.</p>}
            {displayedQuestion.map((qMeta) => getCard(qMeta) )}
        </div>
    )
}